/*
 * Copyright (c) 2024, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import { useContext } from "react";
import { ConfigurationContext } from "./context";

export const useConfiguration = () => {
  const context = useContext(ConfigurationContext);
  if (!context) {
    throw new Error("useConfiguration must be used within a ConfigurationProvider");
  }

  return {
    ...context,
  };
};

export default useConfiguration;
